import Vue from 'vue';
import OS from 'framework/utils/OS';
import { Puzzle } from 'js/crossword/Puzzle';
import { Provider } from "../types";
import Clue from "./Clue";

export interface IActiveClues {
  main: string;
  second: string | null;
}

interface IData {
  activeClues: IActiveClues;
  upAnimated: boolean;
  downAnimated: boolean;
}

Vue.component('clue-column', {
  inject: [Provider.LOCALIZATION],
  data(): IData {
    return {
      activeClues: {
        main: '0',
        second: null,
      },
      upAnimated: false,
      downAnimated: false,
    };
  },
  props: {
    puzzle: Puzzle,
    ui: Object,
    type: String,
  },
  watch: {
    'puzzle.data.currentClueId': {
      handler(newId) {
        this.updateCluesHighlight(newId);
      },
      immediate: true,
    },
    // 'puzzle.data.currentCellId': {
    //   handler() {
    //     this.updateCluesHighlight(this.puzzle.data.currentClueId);
    //   },
    // },
  },
  methods: {
    updateCluesHighlight(newId) {
      this.activeClues.main = newId;
      const secondClue = this.puzzle.getSecondClue();
      this.activeClues.second = secondClue ? secondClue.id : null;

      Object.values(this.activeClues).forEach((clueId) => {
        if (clueId === null) return;
        // @ts-ignore
        const clueRefEl = this.$refs[clueId] && (this.$refs[clueId].$el as Element);
        const parentEl = clueRefEl && clueRefEl.parentElement;
        if (
          clueRefEl &&
          parentEl &&
          parentEl.scrollHeight > parentEl.clientHeight
        ) {
          const parentRect = parentEl.getBoundingClientRect();
          const clueRect = clueRefEl.getBoundingClientRect();
          const relativeCluePosY = clueRect.y - parentRect.y;

          parentEl.scrollTop = parentEl.scrollTop + relativeCluePosY;
        }
      });
    },
    animateUp() {
      this.upAnimated = true;
    },
    animateDown() {
      this.downAnimated = true;
    },
    handleClueClick(id: string) {
      this.activeClues.main = id;
      this.puzzle.setCurrentClue(id);

      if (OS.iPad || OS.android || !OS.desktop) {
        document.getElementById('mobileTextInput')!.focus();
      }
    },
    scroll(direction: number) {
      if (!OS.desktop) return;
      direction < 0 ? this.animateUp() : this.animateDown();
      (this.$refs.clueScrollView as HTMLElement).scrollBy(0, direction * 50);
    },
  },
  render() {
    return (
      <div class='clueColumn'>
        <div
          class={{
            "clueColumn__top": true,
            "clueColumn--clickAnimation": this.upAnimated,
          }}
          onClick={() => this.scroll(-1)}
          onAnimationend={() => this.upAnimated = false}
        >
          <div class='clueColumn__headerTextWrapper'>
            <span
              class={{
                "clueColumn__header": true,
                "clueColumn__header--mobile": !OS.desktop,
              }}>{ this.localization.get(this.type) }</span>
          </div>
          { OS.desktop
            ? <div>
                <div class='clueColumn__arrowBackground'></div>
                <img
                  class={{
                    "clueColumn__topArrow": true,
                    "clueColumn__topArrow--clickAnimation": this.upAnimated
                  }}
                  src='images/Arrow_Down.svg'
                />
              </div>
            : null }
          
        </div>
        <div class='clueColumn__scrollView' ref='clueScrollView'>
          { this.puzzle.data.clues
              .filter((c) => c.type === this.type)
              .map((c) => (
                <Clue
                  key={c.id}
                  puzzle={this.puzzle}
                  clue={c}
                  activeClues={this.activeClues}
                  hidden={this.ui.hiddenClues}
                  onClueClicked={this.handleClueClick}
                  ref={c.id}
                />
              ))}
        </div>

        <div
          class={{
            "clueColumn__footer": true,
            "clueColumn--clickAnimation": this.downAnimated,
          }}
          onClick={() => this.scroll(1)}
          onAnimationend={() => this.downAnimated = false}
        >
          <div class='clueColumn__headerTextWrapper clueColumn__headerTextWrapper--invisible'>
            <span class={{
              "clueColumn__header": true,
              "clueColumn__header--mobile": !OS.desktop
            }}></span>
          </div>
          { OS.desktop
            ? <div>
                <div class='clueColumn__arrowBackground'></div>
                <img
                  class={{
                    "clueColumn__bottomArrow": true,
                    "clueColumn__bottomArrow--clickAnimation": this.downAnimated,
                  }}
                  src='images/Arrow_Down.svg'/>
              </div>
            : null }
        </div>
      </div>
  );
  },
});
